import { useState } from 'react'
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone'
import { Text, Image, Stack, Center } from '@mantine/core'
import { IconUpload, IconPhoto, IconX } from '@tabler/icons-react'
import { notifications } from '@mantine/notifications'
import { uploadFile } from '@/lib/upload'
import { getFileUrl } from '@/lib/api'

interface ImageUploadProps {
  value?: string
  onChange: (url: string) => void
}

export default function ImageUpload({ value, onChange }: ImageUploadProps) {
  const [uploading, setUploading] = useState(false)

  const handleDrop = async (files: File[]) => {
    const file = files[0]
    if (!file) return
    setUploading(true)
    try {
      const result = await uploadFile({ file, type: 'image' })
      onChange(result.url)
      notifications.show({ title: 'Амжилттай', message: 'Зураг хуулагдлаа', color: 'green' })
    } catch {
      notifications.show({ title: 'Алдаа', message: 'Зураг хуулахад алдаа гарлаа', color: 'red' })
    } finally {
      setUploading(false)
    }
  }

  return (
    <Stack gap="xs">
      {value && (
        <Image
          src={getFileUrl(value)}
          h={150}
          w="auto"
          fit="contain"
          radius="md"
        />
      )}
      <Dropzone
        onDrop={handleDrop}
        accept={IMAGE_MIME_TYPE}
        maxSize={10 * 1024 * 1024}
        loading={uploading}
        multiple={false}
      >
        <Center h={100}>
          <Dropzone.Accept>
            <IconUpload size={32} stroke={1.5} />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX size={32} stroke={1.5} />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <Stack align="center" gap={4}>
              <IconPhoto size={32} stroke={1.5} />
              <Text size="sm" c="dimmed">Зураг чирж оруулах эсвэл дарна уу</Text>
            </Stack>
          </Dropzone.Idle>
        </Center>
      </Dropzone>
    </Stack>
  )
}
